import { render } from "./PointPage.vue?vue&type=template&id=0fd9bc10"
import script from "./PointPage.vue?vue&type=script&lang=js"
export * from "./PointPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__